
import { colors, State, StateFlow, StateLine } from 'lqx-react';
import * as React from 'react';
import { OrderCategory, OrderModel } from 'api';

export type CategoryTab = OrderCategory | 'all' | 'separator';

export const categories : CategoryTab[] = [ 'all', 'pending', 'active', 'invoiced', 'inactive', 'separator', 'expired' ];

export function orderStatusColor( status ){
    switch( status ){
        case 'PO Pending' :
            return colors.yellow;

        case 'Unvalidated' :
            return colors.red;
        
        case 'PO Complete' :
        case 'Partially Shipped' :
        case 'Shipped' :
        case 'Partially Invoiced' :
        case 'Invoiced' :
            return colors.green;

        default:
            return colors.grey
    }
}

export const OrderStateFlow = ({ order }) => 
    <StateFlow>
        <State
            checked={ orderChecked( order ) }
            color={ orderColor( order ) }
        >
            Order
        </State>

        <StateLine />
        
        <State
            checked={ shipmentChecked( order ) }
            color={ shipmentColor( order ) }
        >
            Shipment
        </State>

        <StateLine />
        
        <State
            checked={ invoiceChecked( order ) }
            color={ invoiceColor( order ) }
        >
            Invoice
        </State>  
    </StateFlow>

const orderChecked = ( order : OrderModel ) => order.category === 'active' || order.category === 'invoiced' || shipmentChecked( order );
const shipmentChecked = ( order : OrderModel ) => invoiceChecked( order ) || order.status === 'Shipped' || order.status === 'Invoiced' || order.status === 'Partially Invoiced';
const invoiceChecked = ( order : OrderModel ) =>  order.status === 'Invoiced';

function orderColor( order : OrderModel ){
    switch( order.category ){
        case 'pending' :
            return 'blue';

        case 'active' : 
        case 'invoiced' :
            return 'green';

        case 'inactive' :
            return 'grey';

        default:
            return null;
    }
}

function shipmentColor( order : OrderModel ){
    switch( order.category ){
        case 'pending' :
        case 'inactive' :
            return 'grey';

        case 'active' : 
        case 'invoiced' :
            if( order.status === 'Partially Shipped' ) return 'blue';
            if( order.status === 'PO Complete' ) return 'grey';

            return 'green';

        default:
            return 'grey';
    }
}

function invoiceColor( order : OrderModel ){
    if( order.status === 'Partially Invoiced' ) return 'blue';

    if( order.status === 'Invoiced' ) return 'green';

    return 'grey';
}